import { STATUS, statusLabelFor, type SubmissionStatus } from '@commpass/shared';

export function StatusPill({ status, reviewer }: { status: string; reviewer?: boolean }) {
  const s = status as SubmissionStatus;
  const label = STATUS[s] ? statusLabelFor(s, reviewer) : status;
  return (
    <span className={`pill ${status}`}>
      <span className="dot" />
      {label}
    </span>
  );
}
